import React, { useState } from "react";
import "./forgot.css";
import { useMutation } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [forgotData, setForgotData] = useState({
    email: "",
    emailStatus: "unchecked",
  });

  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}/forgot-password`, values);
    },
    onError: (res) => {
      Swal.fire({
        title: res?.response?.data?.error,
        icon: "error",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        setForgotData({
          email: "",
          emailStatus: "unchecked",
        });
      });
    },
    onSuccess: (res) => {
      
      
      Swal.fire({
        title: "Reset link sent your email",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin");
      });
    },
  });

  const checkSubmit = () => {
    let status = true;

    if (forgotData.emailStatus == "success") {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const handleChange = (e) => {
    let newdata = { ...forgotData };
    if (e.target.name == "email") {
      const allCharactersLengthRegex = new RegExp(
        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
      );
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }
    newdata[e.target.name] = e.target.value;
    setForgotData(newdata);
  };

  const handleClick = (e) => {
    e.preventDefault();
    const values = {
      email: forgotData.email,
    };
    mutation.mutate(values);
  };
  return (
    <div className="w-full h-screen flex items-center justify-center">
      {mutation.isLoading && <TraingleLoading />}
      <div class="form-container">
        <div class="logo-container">Forgot Password</div>

        <form class="form">
          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="text"
              value={forgotData.email}
              className={`   ${
                forgotData.emailStatus == "success"
                  ? "input-success"
                  : forgotData.emailStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              id="email"
              name="email"
              placeholder="Enter your email"
              onChange={(e) => handleChange(e)}
            />
          </div>

          <button
            class={`signbutton my-3 ${
              checkSubmit() ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            type="submit"
            disabled={checkSubmit()}
            onClick={(e) => handleClick(e)}
          >
            Send Email
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
